import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ReportState {
  reportName: string
}

const initialState: ReportState = {
  reportName: '',
}

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    save: (state, action: PayloadAction<string>) => {
      state.reportName = action.payload
    },
    clear: (state) => {
      state.reportName = ''
    },
  },
})

export const { save, clear } = reportSlice.actions

export default reportSlice.reducer
